import {defineStore} from 'pinia';
import {watch} from 'vue';
import {setCssVariable} from '@/logged/common/utils';
import {useDisplayMobile} from '@/logged/common/composables';
import {useHeaderNavigationTabs, useSearchDisplayMode, useCurrentPage} from './composables';

export const useHeaderMenu = defineStore('header-menu', () => {
    const {isDisplayMobile} = useDisplayMobile();
    const {searchDisplayMode, searchPreviewTarget, setSearchDisplayModeToForm} = useSearchDisplayMode();

    const {currentPage} = useCurrentPage();

    const headerNavigationTabs = useHeaderNavigationTabs();

    function setTopNavPreviewDesktop() {
        setCssVariable('--header-menu-height', '70px');
        setCssVariable('--header-height', '70px');
        setCssVariable('--header-menu-item-margin-top', '0');
        setCssVariable('--layout-padding-top', '70px');
    }

    function setTopNavPreviewMobile() {
        setCssVariable('--header-menu-height', '145px');
        setCssVariable('--header-height', '145px');
        setCssVariable('--header-menu-item-margin-top', '0');
        setCssVariable('--layout-padding-top', '145px');
    }

    function setTopNavFormDesktop() {
        setCssVariable('--header-menu-height', '100px');
        setCssVariable('--header-height', '100px');
        setCssVariable('--header-menu-item-margin-top', '-30px');
        if (currentPage.value?.pushContent) {
            setCssVariable('--layout-padding-top', '100px');
        } else {
            setCssVariable('--layout-padding-top', '70px');
        }
    }

    function onDisplayModeChange() {
        if (searchDisplayMode.value === 'PREVIEW') {
            if (isDisplayMobile.value) {
                setTopNavPreviewMobile();
            } else {
                setTopNavPreviewDesktop();
            }
        } else if (searchDisplayMode.value === 'FORM') {
            if (isDisplayMobile.value) {
                setTopNavPreviewMobile();
            } else {
                setTopNavFormDesktop();
            }
        } else {
            setTopNavPreviewDesktop();
        }
    }

    function onDisplayMobileChange() {
        onDisplayModeChange();
    }

    watch(searchDisplayMode, onDisplayModeChange, {immediate: true});
    watch(isDisplayMobile, onDisplayMobileChange, {immediate: true});

    return {
        searchDisplayMode,
        searchPreviewTarget,
        setSearchDisplayModeToForm,
        headerNavigationTabs,
    };
});
